import { render, staticRenderFns } from "./button-action-ribbon-menu.vue?vue&type=template&id=838e6374&scoped=true&"
import script from "./button-action-ribbon-menu.vue?vue&type=script&lang=js&"
export * from "./button-action-ribbon-menu.vue?vue&type=script&lang=js&"
import style0 from "./button-action-ribbon-menu.vue?vue&type=style&index=0&id=838e6374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e6374",
  null
  
)

export default component.exports